import { Brand } from '../../../../embedding/dwt-app';
import { FiatRichTextStyle } from '../fiat/fiat-rich-text-style';
import { DsRichTextStyle } from '../ds/ds-rich-text-style';
import { CitRichTextStyle } from '../citroen/cit-rich-text-style';
import { AlfaRichTextStyle } from '../alfa/alfa-rich-text-style';
import { AbarthRichTextStyle } from '../abarth/abarth-rich-text-style';
import { IsuRichTextStyle } from '../isuzu/isu-rich-text-style';
import { JeepRichTextStyle } from '../jeep/jeep-rich-text-style';
import { LanciaRichTextStyle } from '../lancia/lancia-rich-text-style';
import { OpelRichTextStyle } from '../opel/opel-rich-text-style';
import { OpelNewRichTextStyle } from '../opelnew/opelnew-rich-text-style';
import { PeuRichTextStyle } from '../peugeot/peu-rich-text-style';
import { SsgRichTextStyle } from '../ssangyong/ssg-rich-text-style';
export const getRichTextStyleByBrand = (brand: Brand) => {
  switch (brand) {
    case 'fiat':
      return FiatRichTextStyle;
    case 'ds':
      return DsRichTextStyle;
    case 'alfaromeo':
      return AlfaRichTextStyle;
    case 'jeep':
      return JeepRichTextStyle;
    case 'isuzu':
      return IsuRichTextStyle;
    case 'abarth':
      return AbarthRichTextStyle;
    case 'ssangyong':
      return SsgRichTextStyle;
    case 'peugeot':
      return PeuRichTextStyle;
    case 'citroen':
      return CitRichTextStyle;
    case 'opel':
      return OpelRichTextStyle;
    case 'opelold':
      return OpelNewRichTextStyle;
    case 'lancia':
      return LanciaRichTextStyle;
    default:
      return OpelNewRichTextStyle;
  }
};

type Condition = {
  countryCode?: string[];
  brand?: string;
  dealerCodeIncludes?: string[];
};

const ALLOW_EMPTY_P_TAGS_IN_RICH_TEXT: Condition[] = [
  {
    countryCode: ['HU', 'AT', 'BE-FR', 'BE-NL', 'PT', 'PL', 'LU', 'DE', 'BG'],
    brand: 'FIAT',
    dealerCodeIncludes: ['FIHU', 'FIAT', 'FTBEFR', 'FTBENL', 'FIPT', 'FIPL', 'FTLU', 'FTDE', 'FIBG'],
  },
  {
    countryCode: ['HU', 'BE-FR', 'BE-NL', 'AT', 'PT', 'PL', 'LU', 'BG', 'DE'],
    brand: 'JEEP',
    dealerCodeIncludes: ['JEHU', 'JEBEFR', 'JEBENL', 'JEAT', 'JEPT', 'JEPL', 'JELU', 'JEBG', 'JEDE'],
  },
];
export const allowEmptyPTags = (countryCode: string, brand: string, dealerCode: string): boolean => {
  return ALLOW_EMPTY_P_TAGS_IN_RICH_TEXT.some((condition) => {
    const countryMatch = !condition.countryCode || condition.countryCode.includes(countryCode);
    const brandMatch = !condition.brand || condition.brand === brand;
    const dealerMatch =
      !condition.dealerCodeIncludes || condition.dealerCodeIncludes.some((code) => dealerCode?.includes(code));

    return countryMatch && brandMatch && dealerMatch;
  });
};
